import React from "react";

// Keep the grid toolbar mounted when its parent updates filters or selections.
export default function VisiteMedicheToolbar({ children }) {
  return <>{children}</>;
}
